const { default: Sorter } = require("./sorter");

export default class RelevanceSorter extends Sorter {
    /** @inheritdoc */
    sort(a, b) {
        return (this.order === 'desc') ?
            parseInt(b.dataset.relevance) - parseInt(a.dataset.relevance) :
            parseInt(a.dataset.relevance) - parseInt(b.dataset.relevance);
    }
}